import NoteMenuState from "@/stores/NoteMenuState";
import CanvasSettingsState from "@/stores/CanvasSettingsState";
import type { LegendNoteInfoMap } from "@/utils/plan-analysis/plan-context";

/**
 * Libellés + catégories de la légende active, résolus par nom de note — le
 * `defectName` du XData ne porte que le nom. Brique commune de l'envoi du
 * contexte plan à l'IA (onglet Observations) et de l'analyse du plan.
 *
 * Fonction simple (pas un composable réactif) : elle photographie la légende
 * au moment de l'appel, ce qui est le comportement voulu — une analyse ou une
 * génération se fait avec la légende active à cet instant.
 */
export function buildLegendNoteInfo(): LegendNoteInfoMap {
  const noteInfo = new Map<string, { label?: string; category?: string }>();
  const categories = CanvasSettingsState.activeLegend?.categories ?? [];
  for (const note of NoteMenuState.noteConfigs) {
    const category = categories.find((c) => c.noteIds.includes(note.id));
    noteInfo.set(note.name, {
      label: note.label,
      category: category?.name,
    });
  }
  return { noteInfo };
}
